'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    width: 100%;\n    margin-top: ', 'px;\n    margin-right: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n'], ['\n    width: 100%;\n    margin-top: ', 'px;\n    margin-right: ', 'px;\n    margin-bottom: ', 'px;\n    margin-left: ', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    gap: ', 'px;\n    width: 100%;\n    height: ', 'px;\n    padding-left: ', 'px;\n    border-bottom: 3px solid ', ';\n    background-color: ', ';\n    background-image: url(', ');\n    background-size: cover;\n'], ['\n    box-sizing: border-box;\n    display: flex;\n    align-items: center;\n    gap: ', 'px;\n    width: 100%;\n    height: ', 'px;\n    padding-left: ', 'px;\n    border-bottom: 3px solid ', ';\n    background-color: ', ';\n    background-image: url(', ');\n    background-size: cover;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ', 'px;\n    height: ', 'px;\n    border-radius: 50%;\n    border: 3px solid ', ';\n    overflow: hidden;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: ', 'px;\n    height: ', 'px;\n    border-radius: 50%;\n    border: 3px solid ', ';\n    overflow: hidden;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n'], ['\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    font-family: \'Poppins\', sans-serif;\n    font-size: ', 'px;\n    line-height: 1.1;\n    font-weight: 600;\n    color: white;\n    width: min-content;\n    text-shadow: 0 6px 6px rgba(0, 0, 0, 0.75);\n'], ['\n    font-family: \'Poppins\', sans-serif;\n    font-size: ', 'px;\n    line-height: 1.1;\n    font-weight: 600;\n    color: white;\n    width: min-content;\n    text-shadow: 0 6px 6px rgba(0, 0, 0, 0.75);\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    display: flex;\n    justify-content: center;\n    align-items: ', ';\n    width: 100%;\n    height: ', 'px;\n    background-color: white;\n'], ['\n    display: flex;\n    justify-content: center;\n    align-items: ', ';\n    width: 100%;\n    height: ', 'px;\n    background-color: white;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    max-height: ', 'px;\n    max-width: 100%;\n'], ['\n    max-height: ', 'px;\n    max-width: 100%;\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    font-family: \'Poppins\', sans-serif;\n    text-align: center;\n    color: white;\n    font-size: 1.2em;\n'], ['\n    font-family: \'Poppins\', sans-serif;\n    text-align: center;\n    color: white;\n    font-size: 1.2em;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    line-height: 1.2;\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 100;\n'], ['\n    font-size: 12px;\n    line-height: 1.2;\n    text-decoration: underline;\n    cursor: pointer;\n    font-weight: 100;\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    font-size: 12px;\n    font-weight: 100;\n'], ['\n    font-size: 12px;\n    font-weight: 100;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../constants/colors');

var _isMobile = require('../../helpers/isMobile');

var _isMobile2 = _interopRequireDefault(_isMobile);

var _getScreenSize = require('../../helpers/getScreenSize');

var _getScreenSize2 = _interopRequireDefault(_getScreenSize);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _container = require('../../layouts/container');

var _container2 = _interopRequireDefault(_container);

var _grid = require('../../layouts/grid');

var _grid2 = _interopRequireDefault(_grid);

var _row = require('../../layouts/row');

var _row2 = _interopRequireDefault(_row);

var _column = require('../../layouts/column');

var _column2 = _interopRequireDefault(_column);

var _alignments = require('../../constants/alignments');

var _sizes = require('../../constants/sizes');

var _link = require('../../atoms/link');

var _link2 = _interopRequireDefault(_link);

var _label = require('../../atoms/text/label');

var _label2 = _interopRequireDefault(_label);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var BannerWrapper = _styledComponents2.default.div(_templateObject, function (_ref) {
    var top = _ref.top;
    return (0, _getSize2.default)(top);
}, function (_ref2) {
    var right = _ref2.right;
    return (0, _getSize2.default)(right);
}, function (_ref3) {
    var bottom = _ref3.bottom;
    return (0, _getSize2.default)(bottom);
}, function (_ref4) {
    var left = _ref4.left;
    return (0, _getSize2.default)(left);
});

var Header = _styledComponents2.default.div(_templateObject2, function (props) {
    return props.isMobile ? 16 : 36;
}, function (props) {
    return props.isMobile ? 90 : 180;
}, function (props) {
    return props.isMobile ? 30 : 60;
}, function (props) {
    return props.borderColor;
}, _colors.Colors.Primary, function (props) {
    return props.bgImage;
});

var AgentPhotoWraper = _styledComponents2.default.div(_templateObject3, function (props) {
    return props.isMobile ? 60 : 130;
}, function (props) {
    return props.isMobile ? 60 : 130;
}, function (props) {
    return props.photoBorderColor;
});

var Photo = _styledComponents2.default.img(_templateObject4);

var AgentPhotoPlaceholder = function AgentPhotoPlaceholder(_ref5) {
    var fill = _ref5.fill,
        isMobile = _ref5.isMobile;
    return _react2.default.createElement(
        'svg',
        { xmlns: 'http://www.w3.org/2000/svg',
            width: isMobile ? '60px' : '130px',
            height: isMobile ? '60px' : '130px',
            viewBox: '0 0 138 135',
            fill: 'none'
        },
        _react2.default.createElement('path', { d: 'M67 133.002C102.899 133.002 132 104.572 132 69.502C132 34.4319 102.899 6.00195 67 6.00195C31.1015 6.00195 2 34.4319 2 69.502C2 104.572 31.1015 133.002 67 133.002Z',
            fill: 'white'
        }),
        _react2.default.createElement('path', { d: 'M28.5269 113.745C48.4019 130.863 80.6269 135.755 105.182 116.429C106.036 111.026 105.733 105.504 104.293 100.227C102.853 94.9495 100.309 90.0383 96.8289 85.8179C93.3491 81.5976 89.0128 78.1642 84.1068 75.7449C79.2009 73.3257 73.8372 71.9757 68.3706 71.7843C62.9039 71.5928 57.4589 72.5644 52.3958 74.6346C47.3327 76.7048 42.7669 79.8265 39.0004 83.7931C35.2338 87.7598 32.3525 92.481 30.547 97.6444C28.7415 102.808 28.0529 108.296 28.5269 113.745Z',
            fill: fill
        }),
        _react2.default.createElement('path', { d: 'M113.116 0.101209C112.722 -0.0463901 112.285 -0.0320733 111.901 0.141035C111.518 0.314144 111.218 0.631989 111.068 1.02521L106.615 12.8162C106.466 13.2101 106.48 13.6469 106.653 14.0306C106.826 14.4143 107.145 14.7134 107.539 14.8622C107.933 15.011 108.37 14.9972 108.753 14.8239C109.137 14.6507 109.436 14.3321 109.585 13.9382L114.039 2.14721C114.188 1.75348 114.174 1.31683 114.001 0.933195C113.828 0.549559 113.509 0.250316 113.116 0.101209Z',
            fill: 'black'
        }),
        _react2.default.createElement('path', { d: 'M116.699 20.1982L127.587 10.4112C127.745 10.2728 127.874 10.1043 127.967 9.91556C128.059 9.72682 128.113 9.52159 128.126 9.31178C128.138 9.10196 128.109 8.89175 128.04 8.69333C127.97 8.49492 127.862 8.31226 127.722 8.15596C127.581 7.99966 127.411 7.87284 127.221 7.78285C127.031 7.69287 126.825 7.64151 126.615 7.63176C126.405 7.62202 126.195 7.65408 125.998 7.72608C125.8 7.79809 125.619 7.9086 125.465 8.05121L114.577 17.8382C114.27 18.1213 114.088 18.5137 114.068 18.9305C114.049 19.3473 114.195 19.7549 114.473 20.0652C114.752 20.3754 115.142 20.5633 115.559 20.5882C115.975 20.6131 116.385 20.473 116.699 20.1982Z',
            fill: 'black'
        }),
        _react2.default.createElement('path', { d: 'M122.848 25.7792C122.897 26.1618 123.084 26.5134 123.373 26.7684C123.663 27.0235 124.035 27.1645 124.421 27.1652C124.488 27.1652 124.554 27.1612 124.621 27.1532C128.717 26.621 132.672 25.3058 136.271 23.2792C136.453 23.1772 136.614 23.0402 136.743 22.876C136.873 22.7118 136.969 22.5236 137.025 22.3222C137.081 22.1209 137.098 21.9104 137.072 21.7029C137.047 21.4953 136.981 21.2947 136.878 21.1127C136.776 20.9307 136.638 20.7708 136.473 20.6422C136.308 20.5137 136.119 20.4189 135.918 20.3635C135.716 20.3081 135.505 20.293 135.298 20.3192C135.091 20.3454 134.89 20.4124 134.709 20.5162C131.469 22.3395 127.908 23.5226 124.221 24.0012C124.014 24.0277 123.814 24.0948 123.633 24.1985C123.452 24.3022 123.293 24.4406 123.166 24.6057C123.038 24.7708 122.945 24.9595 122.89 25.1608C122.836 25.3622 122.821 25.5723 122.848 25.7792Z',
            fill: 'black'
        }),
        _react2.default.createElement('path', { d: 'M72.2259 61.6222C82.038 59.3028 88.1121 49.4691 85.7929 39.658C83.4737 29.847 73.6393 23.7739 63.8272 26.0934C54.0151 28.4129 47.941 38.2466 50.2602 48.0576C52.5794 57.8686 62.4138 63.9417 72.2259 61.6222Z',
            fill: 'black'
        }),
        _react2.default.createElement('path', { d: 'M46.3679 130.139C50.4209 131.699 55.2489 132.366 59.4209 133.091C82.8099 137.157 105.848 133.415 112.601 130.091C113.103 129.838 113.508 129.428 113.755 128.923C114.001 128.418 114.076 127.846 113.966 127.295C113.857 126.744 113.57 126.244 113.15 125.871C112.729 125.498 112.198 125.273 111.638 125.231C106.375 124.925 101.095 125.189 95.8889 126.019C116.865 115.727 130.908 94.0602 132.109 72.1862C134.489 29.1392 94.4229 -0.425791 55.8209 6.66921C2.20586 11.1292 -11.0601 74.4862 8.64486 103.496C16.5519 115.138 31.1669 126.329 46.3679 130.139ZM105.182 116.429C80.6269 135.755 48.4019 130.863 28.5269 113.745C28.0529 108.296 28.7415 102.808 30.547 97.6444C32.3525 92.481 35.2338 87.7598 39.0004 83.7931C42.7669 79.8265 47.3327 76.7048 52.3958 74.6346C57.4589 72.5644 62.9039 71.5928 68.3706 71.7842C73.8372 71.9757 79.2009 73.3256 84.1068 75.7449C89.0128 78.1642 93.3491 81.5975 96.8289 85.8179C100.309 90.0383 102.853 94.9495 104.293 100.227C105.733 105.504 106.036 111.026 105.182 116.429ZM20.3309 32.2532C55.5309 -14.3748 132.172 13.6162 128.931 72.0112C127.762 87.9049 120.516 102.738 108.698 113.429C109.11 107.814 108.383 102.174 106.561 96.8463C104.74 91.519 101.86 86.6146 98.0965 82.4274C94.3326 78.2402 89.7616 74.8565 84.6578 72.4795C79.554 70.1024 74.0226 68.7809 68.3955 68.5943C62.7684 68.4076 57.1615 69.3597 51.9114 71.3934C46.6614 73.4271 41.8762 76.5004 37.8432 80.429C33.8101 84.3575 30.6123 89.0604 28.4415 94.2553C26.2708 99.4502 25.1719 105.03 25.2109 110.66C4.23786 89.7082 3.38386 54.7012 20.3309 32.2532Z',
            fill: 'black'
        })
    );
};

var AgentName = _styledComponents2.default.div(_templateObject5, function (props) {
    return props.isMobile ? 24 : 50;
});

var Footer = _styledComponents2.default.div(_templateObject6, function (props) {
    return props.isMobile ? 'flex-start' : 'center';
}, function (props) {
    return props.footerHeight ? props.footerHeight : 0;
});

var CompanyLogo = _styledComponents2.default.img(_templateObject7, function (props) {
    return props.isMobile ? 24 : 36;
});

var LogoPlaceholder = _styledComponents2.default.p(_templateObject8);

var LinkStyled = (0, _styledComponents2.default)(_link2.default)(_templateObject9);

var SmallLabel = (0, _styledComponents2.default)(_label2.default)(_templateObject10);

var DisplayBanner = function DisplayBanner(_ref6) {
    var fullName = _ref6.fullName,
        phone = _ref6.phone,
        email = _ref6.email,
        license = _ref6.license,
        profileImage = _ref6.profileImage,
        hasProfileImage = _ref6.hasProfileImage,
        context = _ref6.context,
        _ref6$photoBorderColo = _ref6.photoBorderColor,
        photoBorderColor = _ref6$photoBorderColo === undefined ? _colors.Colors.Secondary : _ref6$photoBorderColo,
        top = _ref6.top,
        bottom = _ref6.bottom,
        left = _ref6.left,
        right = _ref6.right;

    var _useState = (0, _react.useState)(true),
        _useState2 = _slicedToArray(_useState, 2),
        photoExists = _useState2[0],
        setPhotoExists = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        logoExists = _useState4[0],
        setLogoExists = _useState4[1];

    var isMobile = (0, _isMobile2.default)((0, _getScreenSize2.default)());
    var companyLogo = process.env.PUBLIC_URL + '/assets/logo_light.svg';
    var bgImage = process.env.PUBLIC_URL + '/assets/agentbanner_bg.png';
    var footerHeight = 48 + (isMobile && email ? 15 : 0) + (isMobile && license ? 18 : 0) + (isMobile && phone ? 15 : 0);

    var handleImageError = function handleImageError() {
        setPhotoExists(false);
    };
    var handleLogoLoad = function handleLogoLoad() {
        setLogoExists(true);
    };
    var handleLogoError = function handleLogoError() {
        setLogoExists(false);
    };

    (0, _react.useEffect)(function () {
        setPhotoExists(hasProfileImage);
    }, []);

    return _react2.default.createElement(
        BannerWrapper,
        { isMobile: isMobile,
            top: top,
            bottom: bottom,
            left: left,
            right: right
        },
        _react2.default.createElement(
            Header,
            {
                isMobile: isMobile,
                borderColor: photoBorderColor,
                bgImage: bgImage
            },
            photoExists ? _react2.default.createElement(
                AgentPhotoWraper,
                { isMobile: isMobile,
                    photoBorderColor: photoBorderColor
                },
                _react2.default.createElement(Photo, { src: profileImage,
                    alt: 'Agent',
                    onError: handleImageError
                })
            ) : _react2.default.createElement(AgentPhotoPlaceholder, { fill: photoBorderColor,
                isMobile: isMobile
            }),
            _react2.default.createElement(
                AgentName,
                { isMobile: isMobile },
                fullName
            )
        ),
        _react2.default.createElement(
            Footer,
            { isMobile: isMobile,
                footerHeight: footerHeight
            },
            _react2.default.createElement(
                _grid2.default,
                null,
                _react2.default.createElement(
                    _row2.default,
                    null,
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 4
                        },
                        license && !isMobile && _react2.default.createElement(
                            _container2.default,
                            { fullSize: true,
                                horizontalAlignment: _alignments.Alignments.left,
                                verticalAlignment: _alignments.Alignments.center,
                                left: isMobile ? _sizes.Sizes.none : _sizes.Sizes.xs
                            },
                            _react2.default.createElement(SmallLabel, {
                                text: license,
                                size: _sizes.Sizes.xs,
                                textAlign: isMobile ? _alignments.Alignments.center : _alignments.Alignments.left
                            })
                        )
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 4
                        },
                        _react2.default.createElement(
                            _container2.default,
                            { fullSize: true,
                                horizontalAlignment: _alignments.Alignments.center,
                                verticalAlignment: _alignments.Alignments.center
                            },
                            logoExists ? _react2.default.createElement(CompanyLogo, { src: companyLogo,
                                alt: 'Company Logo',
                                onLoad: handleLogoLoad,
                                onError: handleLogoError,
                                isMobile: isMobile
                            }) : _react2.default.createElement(
                                LogoPlaceholder,
                                null,
                                fullName,
                                ' Mortgage Professional'
                            )
                        )
                    ),
                    _react2.default.createElement(
                        _column2.default,
                        { xs: 12,
                            md: 4
                        },
                        _react2.default.createElement(
                            _container2.default,
                            { fullSize: true,
                                horizontalAlignment: _alignments.Alignments.left,
                                verticalAlignment: _alignments.Alignments.center,
                                left: isMobile ? _sizes.Sizes.none : _sizes.Sizes.xs,
                                top: isMobile ? _sizes.Sizes.xs : _sizes.Sizes.none
                            },
                            license && isMobile && _react2.default.createElement(SmallLabel, {
                                text: license,
                                size: _sizes.Sizes.xs,
                                textAlign: isMobile ? _alignments.Alignments.center : _alignments.Alignments.left
                            }),
                            phone && _react2.default.createElement(LinkStyled, { href: 'tel:' + phone,
                                text: phone,
                                size: _sizes.Sizes.xs,
                                textAlign: isMobile ? _alignments.Alignments.center : _alignments.Alignments.left
                            }),
                            email && _react2.default.createElement(LinkStyled, { href: 'mailto:' + email,
                                text: email,
                                size: _sizes.Sizes.xs,
                                textAlign: isMobile ? _alignments.Alignments.center : _alignments.Alignments.left
                            })
                        )
                    )
                )
            )
        )
    );
};

AgentPhotoPlaceholder.propTypes = {
    fill: _propTypes2.default.string.isRequired,
    isMobile: _propTypes2.default.string.isRequired
};

DisplayBanner.propTypes = {
    context: _propTypes2.default.object.isRequired,
    fullName: _propTypes2.default.string,
    phone: _propTypes2.default.string,
    email: _propTypes2.default.string,
    license: _propTypes2.default.string,
    photoBorderColor: _propTypes2.default.string,
    top: _propTypes2.default.string,
    bottom: _propTypes2.default.string,
    left: _propTypes2.default.string,
    right: _propTypes2.default.string
};

exports.default = DisplayBanner;